import { createTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import dayjs from "dayjs";
import React, { Suspense } from "react";
import { connect } from "react-redux";
// import Header from '../components/header/index';
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { bindActionCreators } from "redux";
import Login from "../../containers/login";
// import queryString from 'query-string';
// import { withCookies } from 'react-cookie';
import {
  setHeaderDate_From,
  setHeaderDate_To,
  setHeaderUnit,
  setStatesBasedHierarchyToken,
  triggerFetchAllEndPoints,
  triggerFetchFilterList,
  triggerFetchHierarchyTiles,
  triggerFetchRetailerCategory,
  triggerFetchTrans,
  triggerFetchUserConf,
  triggerJCAreaFilter,
  triggerSegregateDataForRole,
  triggerSetSelectedOptionData,
  updateFilterValue,
} from "../../redux/actions";
import {
  triggerShowHeader,
  triggerShowSidebar,
} from "../../redux/actions/action";
import {
  getPartnerRoleID,
  getPartnerRoleName,
  validatePartnerRoleType,
} from "../common";
import { CustomHeader } from "../../components/customHeader/index";
import { SideBar } from "../../components/sideBar/index";
import config from "./index";
import myRoutes from "./routeConfig";
import Spinner from "../../components/presentationals/Spinner";
import ErrorPage from "../../views/errorPages/errorPage";
// In-app listeners for filter persistence rules (reset on Home/back; reseed hierarchy after reset).
import DashboardFilterResetListener from "../../components/DashboardFilterResetListener";
import DashboardHierarchyReseedListener from "../../components/DashboardHierarchyReseedListener";
import { filterNames } from "../constants";
import store from "../../redux/store/index";

class App extends React.Component {
  constructor(props) {
    super(props);
    // Stable callback passed to DashboardHierarchyReseedListener; reuses existing fetchAPI (post-login seeding).
    this.runHierarchySeed = () => this.fetchAPI(this.props);
    this.state = {
      selectedDateFrom: "18-Aug-2019",
      selectedDateTo: "18-Aug-2019",
      unit: null,
      tokenExpired: false,
      sessionExpire: false,
      unAuthorizedUser: false,
      msg: "",
      isHierarchyFetched: false,
      showHeader: false,
    };
  }

  fetchJCJP = (props, id, PRT) => {
    let obj = {
      headers: {
        "Content-Type": "application/json",
        SAN: props.filterValue.SAN,
      },
      params: {
        areaJcFlag: PRT === "JCJP" ? "JP" : PRT,
        id: id,
        jpFlag: PRT,
      },
    };
    props.triggerJCAreaFilter(
      obj,
      PRT === "JCJP" ? "RDS/ARD/MARD" : PRT,
      async (res) => {
        if (PRT === "AREA") {
          await props.triggerSetSelectedOptionData({
            ...props.selectedOptionData,
            JC: res.content[0],
          });
          this.fetchJCJP(
            this.props,
            res && res.content && res.content[0],
            "JC",
          );
        } else {
          // this.setDefaultFilterValues(res && res.content && res.content[0]);
          if (PRT === "JC") {
            let resp = res && res.content && res.content[0];
            let PRRT = resp && resp.split(" - ")[0].trim();

            let obj = {
              ...this.props.filterValue,
              selectedRole: resp,
              selectedPartnerRoleType: getPartnerRoleID(PRRT),
              selectedPartnerRoleName: PRRT,
            };
            await this.props.updateFilterValue(obj);
            this.fetchHierarchy(props, { PRT: getPartnerRoleID(PRRT) });
            await props.triggerSetSelectedOptionData({
              ...props.selectedOptionData,
              "RDS/ARD/MARD": res.content[0],
            });

            this.fetchJCJP(
              props,
              resp && resp.split(" - ")[resp.split(" - ").length - 1],
              "JCJP",
            );
          }
        }
      },
    );
  };

  fetchRetailCat = () => {
    if (
      this.props.filterValue.site.toLowerCase() ===
      filterNames.mobility.toLowerCase()
    ) {
      this.props.triggerFetchRetailerCategory();
    }
  };

  setDefaultFilterValues = (obb) => {
    let obj = {
      ...this.props.filterValue,
      selectedRole:
        obb &&
        getPartnerRoleName(obb.partnerRoleType) +
          " - " +
          obb.partnerName +
          " - " +
          obb.partnerId,
      selectedPartnerRoleType: obb && obb.partnerRoleType,
      selectedPartnerRoleName: obb && getPartnerRoleName(obb.partnerRoleType),
    };
    this.props.updateFilterValue(obj);
  };

  fetchHierarchy = (props, pObj) => {
    props.triggerFetchAllEndPoints(
      {
        role:
          props.filterValue.site.toLowerCase() === filterNames.smb.toLowerCase()
            ? filterNames.end
            : props.filterValue.site.toLowerCase() ===
                filterNames.fiber.toLowerCase()
              ? filterNames.jba
              : pObj.PRT
                ? pObj.PRT
                : props.filterValue.selectedPartnerRoleType,
        roleType: props.filterValue.partnerName.toUpperCase(),
        partnerRoleType: props.filterValue.partnerName,
        site: props.filterValue.site,
        forTiles: "NO",
      },
      () => {
        sessionStorage.clear();
        this.setState({
          unAuthorizedUser: true,
        });
      },
    );
    let CategoryVar = pObj.PRT ? pObj.PRT : props.partnerRoleType;
    if (
      CategoryVar !== "" &&
      CategoryVar !== "ZDMT" &&
      CategoryVar !== "DT" &&
      CategoryVar !== "END" &&
      CategoryVar !== "ITZ" &&
      CategoryVar !== "XG"
    ) {
      this.fetchRetailCat();
    }
  };

  fetchStates = (props, state) => {
    let obj = {
      state: state ? state : props.filterValue.selectedState,
    };
    let self = this;
    if (
      this.props.filterValue.site.toLowerCase() ===
      filterNames.mobility.toLowerCase()
    ) {
      props.triggerFetchFilterList(obj, async (res) => {
        let PRT = res && res.content && res.content[0]?.partnerRoleType;
        let PRN =
          res &&
          res.content &&
          getPartnerRoleName(res.content[0]?.partnerRoleType) +
            " - " +
            res.content[0]?.partnerName +
            " - " +
            res.content[0]?.partnerId;
        self.fetchHierarchy(props, { PRT, PRN });
        // let option = "ZD/ZDMT/ARD/MARD";
        // let data = PRN;
        // props.triggerSegregateDataForRole({ data, option });
        let data = "North";
        let option = "Region";
        if (props.partnerRoleType === "REGION") {
          option = props.partnerRoleType;
          data =
            props.filterValue.selectedRegion.charAt(0).toUpperCase() +
            props.filterValue.selectedRegion.slice(1).toLowerCase();
        }
        await props.triggerSegregateDataForRole({ data, option });
        await props.triggerSegregateDataForRole({
          data: state,
          option: "State",
        });
        await props.triggerSegregateDataForRole({
          data: PRN,
          option: "ZD/ZDMT/ARD/MARD",
        });

        // Use latest Redux slice: filterSchemeType may resolve while these awaits run; props can be
        // stale and would drop Scheme_Type / Scheme from selectedOptionData (empty dropdown value + RUN disabled).
        const latestSelected =
          store.getState().homeReducer.selectedOptionData || {};
        this.props.triggerSetSelectedOptionData({
          ...latestSelected,
          [option]: data,
          State: state ? state : "",
          "ZD/ZDMT/ARD/MARD": PRN,
          "RDS/Chain": "ALL",
        });
        self.setDefaultFilterValues(res && res.content && res.content[0]);
      });
    } else {
      self.fetchHierarchy(props, {});
    }
  };

  //first api call
  fetchHierarchyTiles = (site) /*PRT*/ => {
    this.props.triggerFetchHierarchyTiles(
      {
        forTiles: "YES",
        ...(site
          ? { site: site }
          : this.props.filterValue.site !== "" && {
              site: this.props.filterValue.site,
            }),
      },
      async (res) => {
        this.setState({
          isHierarchyFetched: true,
        });
        await this.props.setStatesBasedHierarchyToken(res && res.extraData);
        this.fetchAPI(this.props);
      },
      (response) => {
        sessionStorage.clear();
        if (response.message === "UnAuthorized User") {
          this.setState({
            unAuthorizedUser: true,
          });
        } else {
          this.setState({
            tokenExpired: true,
            msg: response.message,
          });
        }
        // alert(this.props.history)
        // this.props.history.push("tokenExpire");
      },
    );
  };

  fetchAPI = async (props) => {
    if (!validatePartnerRoleType(props.partnerRoleType)?.businessType) {
      props.triggerFetchAllEndPoints(
        {
          roleType:
            props.filterValue.site === filterNames.smb
              ? filterNames.end
              : props.filterValue.site === filterNames.fiber
                ? filterNames.jba
                : "",
          forTiles: "NO",
          role: props.filterValue.selectedPartnerRoleType,
          partnerRoleType: props.filterValue.partnerName,
          site: props.filterValue.site,
        },
        () => {
          sessionStorage.clear();
          this.setState({
            unAuthorizedUser: true,
          });
        },
      );
      let CategoryVar = props.partnerRoleType;
      if (
        CategoryVar !== "" &&
        CategoryVar !== "ZDMT" &&
        CategoryVar !== "DT" &&
        CategoryVar !== "END" &&
        CategoryVar !== "ITZ" &&
        CategoryVar !== "XG"
      ) {
        this.fetchRetailCat();
      }
    } else {
      this.fetchRetailCat();
      if (props.partnerRoleType === "STATE") {
        this.fetchStates(props);
      } else if (props.partnerRoleType === "NHQ") {
        await props.triggerSegregateDataForRole();
        this.fetchStates(props, "Delhi");
      } else if (props.partnerRoleType === "REGION") {
        // let option = props.partnerRoleType;
        // let data = props.filterValue.selectedRegion.charAt(0).toUpperCase() + props.filterValue.selectedRegion.slice(1).toLowerCase();
        // props.triggerSegregateDataForRole({ data, option });
        let stateForRegion =
          config.states[
            props.filterValue.selectedRegion.charAt(0).toUpperCase() +
              props.filterValue.selectedRegion.slice(1).toLowerCase()
          ][0];
        this.fetchStates(props, stateForRegion);
      } else {
        if (
          props.partnerRoleType === "AREA" ||
          props.partnerRoleType === "JC" ||
          props.partnerRoleType === "JP"
        ) {
          if (props.partnerRoleType === "JP") {
            this.props.triggerFetchAllEndPoints(
              {
                roleType: props.filterValue.partnerName,
                forTiles: "NO",
                role: props.partnerRoleType,
                partnerRoleType: props.filterValue.partnerName,
                site: props.filterValue.site,
              },
              () => {
                sessionStorage.clear();
                this.setState({
                  unAuthorizedUser: true,
                });
              },
            );
          }
          this.fetchJCJP(
            props,
            props.filterValue.selectedArea,
            props.partnerRoleType,
          );
        }
      }
    }
  };

  componentDidMount() {
    if (
      // sessionStorage.getItem("pctoken") &&
      !window.location.href.includes("sessionExpired")
    ) {
      this.fetchHierarchyTiles(this.props.filterValue.site);
    }
    // if (this.props.partnerRoleType) {
    //     this.fetchAPI(this.props);
    // }
  }
  getSelectedDateFromHandler = (date) => {
    this.props.setHeaderDate_From(dayjs(date).format("DD-MMM-YYYY"));
  };

  getSelectedDateToHandler = (date) => {
    this.props.setHeaderDate_To(dayjs(date).format("DD-MMM-YYYY"));
  };

  getValueUnitHandler = (unit) => {
    this.props.setHeaderUnit(unit);
  };

  //function to set showsidebar to true in custom header upon button click
  setShowSidebar = () => {
    // console.log("SETTING SHOWHEADER TO TRUE...");
    this.props.triggerShowSidebar(!this.props.showSidebar);
  };

  onRouteChange(component, routeObject) {
    let ComponentName = component;
    window.history.replaceState(
      {},
      document.title,
      `${config.configBase}${routeObject.path}`,
    );
    // const currentYear = new Date().getFullYear();
    // console.log("component", ComponentName);
    // console.log("routeObj", routeObject);
    return (
      <>
        <div
          className={
            this.state.tokenExpired ||
            this.state.unAuthorizedUser ||
            global.isSessionExpired ||
            window.location.href.includes("sessionExpired")
              ? ""
              : "con-wrapper"
          }
        >
          <ComponentName errMsg={this.state.msg} />
        </div>
      </>
    );
  }

  render() {
    // let abc = sessionStorage.getItem("isSessionExpired");

    let routes2 =
      this.props.partnerRoleType &&
      myRoutes[this.props.partnerRoleType].map((el, index) => {
        return (
          <Route
            exact={true}
            key={index}
            path={el.path}
            render={(routeProps) => this.onRouteChange(el.component, el)}
          />
        );
      });

    if (this.state.tokenExpired) {
      routes2 = myRoutes["TOKEN_EXPIRE"].map((el, index) => {
        return (
          <Route
            exact={true}
            key={index}
            path={el.path}
            render={(routeProps) => this.onRouteChange(el.component, el)}
          />
        );
      });
    }
    if (this.state.unAuthorizedUser) {
      routes2 = myRoutes["UN_AUTH"].map((el, index) => {
        return (
          <Route
            exact={true}
            key={index}
            path={el.path}
            render={(routeProps) => this.onRouteChange(el.component, el)}
          />
        );
      });
    }

    if (window.location.href.includes("sessionExpired")) {
      routes2 = myRoutes["SESSION_EXPIRED"].map((el, index) => {
        return (
          <Route
            exact={true}
            key={index}
            path={el.path}
            render={(routeProps) => this.onRouteChange(el.component, el)}
          />
        );
      });
    }

    return (
      <>
        <ThemeProvider theme={theme}>
          <BrowserRouter basename={config.configBase}>
            {/* Must be under BrowserRouter for useLocation; render null — no UI */}
            <DashboardFilterResetListener />
            <DashboardHierarchyReseedListener
              runHierarchySeed={this.runHierarchySeed}
            />
            <Suspense>
              <Switch>
                <>
                  <div className="wrapper">
                    {
                      // when the request is still in pending phase (i.e, tilesData loading is true), show loading sign
                      this.props.tilesData?.loading ? (
                        <Spinner />
                      ) : /*when the request is NOT in pending phase (i.e, tilesData loading is false) 
                      but there is some error - request timed out or any other unexpected error, only show error page*/

                      this.props.tilesData?.error ? (
                        <div id="content">
                          <ErrorPage />
                        </div>
                      ) : (
                        <>
                          {
                            <SideBar
                              // isHeaderVisible={this.props.showHeader}
                              setShowSidebar={this.setShowSidebar}
                            />
                          }
                          <div id="content">
                            {!this.state.tokenExpired &&
                            !this.state.unAuthorizedUser ? (
                              // this.props.showHeader ?
                              <CustomHeader
                                isHierarchyFetched={
                                  this.state.isHierarchyFetched
                                }
                                selectedDateFromHandler={
                                  this.getSelectedDateFromHandler
                                }
                                selectedDateToHandler={
                                  this.getSelectedDateToHandler
                                }
                                valueUnitHandler={this.getValueUnitHandler}
                                setShowSidebar={this.setShowSidebar}
                                fetchHierarchyTiles={this.fetchHierarchyTiles}
                              />
                            ) : null}

                            {routes2}
                          </div>
                        </>
                      )
                    }
                  </div>
                  <div
                    // className="overlay"
                    className={
                      this.props.showHeader ? "overlay-active" : "overlay"
                    }
                    data-cy="overlay"
                    onClick={() => this.setShowHeader()}
                  ></div>
                </>
                {/* <Route exact path="/tokenExpire" component={TokenExpire} />
                                <Route exact path="/unAuthorized" component={UnAuthorized} /> */}
              </Switch>
            </Suspense>
          </BrowserRouter>
        </ThemeProvider>
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let {
    filterList,
    filterValue,
    partnerRoleType,
    selectedOptionData,
    tilesData,
    storedToken,
    showHeader,
    showSidebar,
  } = state.homeReducer;
  // let { translations } = state.persistedReducer;
  return {
    filterList,
    filterValue,
    // translations,
    partnerRoleType,
    cookies: ownProps.cookies,
    selectedOptionData,
    tilesData,
    storedToken,
    showHeader,
    showSidebar,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      triggerFetchFilterList,
      triggerFetchAllEndPoints,
      setHeaderDate_From,
      setHeaderDate_To,
      setHeaderUnit,
      triggerFetchTrans,
      triggerFetchUserConf,
      triggerSegregateDataForRole,
      triggerFetchRetailerCategory,
      triggerJCAreaFilter,
      triggerSetSelectedOptionData,
      updateFilterValue,
      triggerFetchHierarchyTiles,
      setStatesBasedHierarchyToken,
      triggerShowHeader,
      triggerShowSidebar,
    },
    dispatch,
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(App);

const theme = createTheme({
  palette: {
    // type: 'dark',
    primary: {
      main: "#962828",
    },
    secondary: {
      main: "#cfd8dc",
    },
    success: {
      main: "#e8e3e3",
    },
    default: {
      main: "#265a88",
    },
  },
  overrides: {
    // Style sheet name ⚛️
    MuiButton: {
      text: {
        borderRadius: 3,
        border: 0,
        color: "white",
        height: 48,
        padding: "0 30px",
        boxShadow: "0 3px 5px 2px rgba(255, 105, 135, .3)",
      },
    },
  },
});
